export { default as PricingMatrix } from './primary';
